import { HeadingModule } from '@agingplan';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsModule } from 'src/app/components/components.module';
import { AboutComponent } from './about.component';
import { ArrayPageNavigationComponent } from './array-page-navigation/array-page-navigation.component';
import { EmployeeComponent } from './employee/employee.component';
import { EmployeesComponent } from './employees/employees.component';

const routes: Routes = [
  {
    path: '',
    component: AboutComponent,
    children: [
      { path: '', component: EmployeesComponent, pathMatch: 'full' },
      {
        path: 'employee',
        children: [
          { path: '', redirectTo: '0', pathMatch: 'full' },
          { path: ':index', component: EmployeeComponent },
          { path: '**', redirectTo: '0', pathMatch: 'full' },
        ],
      },
      { path: '**', redirectTo: 'employees', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  declarations: [AboutComponent, ArrayPageNavigationComponent, EmployeeComponent, EmployeesComponent],
  exports: [RouterModule],
  imports: [CommonModule, RouterModule.forChild(routes), ComponentsModule, HeadingModule],
})
export class AboutModule {}
